<template>
    <div id="tab-bar">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'TabBar'
}
</script>
<style scoped>
#tab-bar {
    display: grid;
    grid-template-columns: 1.8rem repeat(5, 1fr);
    margin-right: 2%;
    justify-items: start;
    height: 75px;
    color: #ffffff;
    width: 38%;
}
</style>



// WEBPACK FOOTER //
// src/components/NavigatBar/NavigatBar.vue